import React, { useCallback, useEffect, useState } from "react";
import FilterHeader from "../FilterHeader";
import TabHeaders from "../TabHeaders";
import styles from "./ViewPanel.module.css";
import ViewRow from "./ViewRow";
import { FormStudioService } from "../../../../../../api";
import { useApi } from "../../../../../../common/hooks";
import { isNonEmptyArray } from "../../../../../../common/utils";

const sortViews = (views, direction) =>
	[...views].sort((a, b) => (direction === "desc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)));
export default function ViewPanel({ refreshList, onOpenCreation, onSelectPanel }) {
	const [views, setViews] = useState([]);
	const [sortDirection, setSortDirection] = useState("desc");
	const [sortKey, setSortKey] = useState("");
	const [searchViewName, setSearchViewName] = useState("");
	const { call: getAllViews } = useApi(FormStudioService.getAllViews);
	const { call: duplicateView } = useApi(FormStudioService.duplicateView);
	const { call: deleteView } = useApi(FormStudioService.deleteView);
	const retrieveViews = useCallback(
		(name) => {
			getAllViews({ name })
				.then((savedViews) => {
					setViews(savedViews);
				})
				.catch(console.error);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);
	useEffect(() => {
		retrieveViews(searchViewName);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchViewName, refreshList]);
	useEffect(() => {
		setViews((prev) => sortViews(prev, sortDirection));
	}, [sortDirection]);
	const handleChangeFilters = ({ name }) => {
		setSearchViewName(name);
	};
	const handleDeleteView = (pageId) => {
		deleteView({ pageId })
			.then(() => retrieveViews(searchViewName))
			.catch(console.error);
	};
	const handleDuplicateView = (pageId) => {
		duplicateView({ pageId })
			.then(() => retrieveViews(searchViewName))
			.catch(console.error);
	};
	const handleClickSort = (newKey) => {
		if (newKey === sortKey) {
			setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
		} else {
			setSortKey(newKey);
			setSortDirection("asc");
		}
	};
	const handleOpen = () => {
		onOpenCreation();
	};
	const rowRenderer = (view) => (
		<ViewRow
			key={view.id}
			view={view}
			onDelete={handleDeleteView}
			onDuplicate={handleDuplicateView}
			onOpenEdition={onOpenCreation}
			onSelectPanel={onSelectPanel}
		/>
	);
	return (
		<div className={styles.container}>
			<FilterHeader
				actionTitle="dsi.form-studio.view.new.button"
				onChangeFilters={handleChangeFilters}
				onOpen={handleOpen}
			/>
			<TabHeaders panel={0} sortDirection={sortDirection} sortKey={sortKey} onClickSort={handleClickSort} />
			<div className={styles.list}>{isNonEmptyArray(views) && views.map((row) => rowRenderer(row))}</div>
		</div>
	);
}
